// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"ModalKitchenStopList_fieldset__1XEWg","modalBody":"ModalKitchenStopList_modalBody__bDJO0","btnWrapper":"ModalKitchenStopList_btnWrapper__2Lrdq"};